(function(){
    'use strict'; 
    angular.module('Directives').directive('deliveryChecklist', deliveryChecklist);
    deliveryChecklist.$inject = [];

    function deliveryChecklist() {
        return {
            restrict: 'E',
            templateUrl : '/templates/directives/components/shipment-details/delivery-checklist.html', 
            scope: {
                jobData: '='
            },
            link: deliveryChecklistLink
        }

        function deliveryChecklistLink($scope, $elems, $attrs) {
            init();
            
            function init() {
                $scope.job = $scope.jobData;
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/shipment-details/deliveryChecklist.js